const MarqueeOff = () => {
    const msg = document.getElementById('short-msg');
    msg.style.display = 'none';
};

export default MarqueeOff;